import React, {Children, cloneElement, ReactElement} from "react";
import styles from './Quote.module.scss'
import Experiences from "@/Molecules/Experiences/Experiences";



export const Quote = (
  {
    className,
    content,
    author,
  }: {
    className?: any,
    content: any,
    author: string
}) => {

  return <section className={`py-10 ${className ?? ''}`}>
    <div className="container">
      <div className={styles.quoteWrapper}>
        <div className={styles.quote}>
          "{content}"
        </div>
        <div className={styles.author}>{author}</div>
      </div>
    </div>
  </section>

}

export default Quote;
